;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export enum ProviderType {
	YARDI = "YARDI",
	APP_FOOLIO = "APP_FOOLIO",
	OPINIION = "OPINIION",
	GADMIN = "GADMIN",
	GMELIUS = "GMELIUS",
	APPFOLIO_DATABASE = "APPFOLIO_DATABASE",
	QUICKBOOKS = "QUICKBOOKS",
	PODIUM = "PODIUM",
	GOTO_CONNECT = "GOTO_CONNECT",
	CALL_LINKS = "CALL_LINKS",
	SHOWMOJO = "SHOWMOJO",
	ASANA = "ASANA",
	RENTVINE = "RENTVINE",
	ZOOM = "ZOOM",
	RENTENGINE = "RENTENGINE",
}

export interface YardiCredentials {
	apiKey: string;
}

export interface AppFoolioCredentials {
	clientId: string;
	clientSecret: string;
}

export interface OpiniionCredentials {
	email: string;
	password: string;
}

export interface GAdminCredentials {
	superAdminEmail: string;
}

export interface GmeliusCredentials {
	clientId: string;
	clientSecret: string;
}

export interface QuickbooksCredentials {
	realmId: string;
	accessToken: string;
	refreshToken: string;
	expiresAt: number;
	refreshTokenExpiresAt: number;
}

export interface ZoomCredentials {
	accessToken: string;
	refreshToken: string;
	expiresAt: number;
	refreshTokenExpiresAt: number;
	scope: string;
}

export interface PodiumCredentials {
	accessToken: string;
	expiresAt: number;
	collectionStartAt?: string | null;
	isPending?: boolean;
	organizationConnections?: PodiumOrganizationConnection[];
	/** @deprecated Read-only compatibility for pending legacy setup. */
	organizationChoices?: PodiumOrganizationChoice[];
	/** @deprecated Read-only compatibility for a legacy single target. */
	organizationName?: string;
	/** @deprecated Read-only compatibility for a legacy single target. */
	organizationUid?: string;
	refreshToken: string;
	clientId?: string;
	clientSecret?: string;
	refreshTokenExpiresAt?: number;
	scope?: string[];
	state?: string | null;
}

export interface PodiumOrganizationChoice {
	organizationName: string;
	organizationUid: string;
}

export interface PodiumOrganizationConnection {
	organizationName: string;
	organizationUid: string;
}

export interface GoToConnectAccountChoice {
	accountKey: string;
	accountName: string;
}

export interface GoToConnectCredentials {
	accountChoices?: GoToConnectAccountChoice[];
	accountKey?: string;
	accountName?: string;
	accessToken?: string;
	expiresAt?: number;
	isPending?: boolean;
	principal?: string;
	reconnectRequired?: boolean;
	refreshToken?: string;
	refreshTokenExpiresAt?: number;
}

export interface CallLinksCredentials {
	databaseName: string;
}

export interface ShowMojoCredentials {
	apiToken: string;
}

export interface AsanaCredentials {
	personalAccessToken: string;
	workspaceGid?: string;
	workspaceName?: string;
	projectIds?: string[];
	projectNames?: string[];
}

export interface RentvineCredentials {
	databaseName: string;
	clientId: string;
	clientSecret: string;
}

export interface RentEngineCredentials {
	apiKey: string;
	accountId: string;
}

export type DataProviderCredentials =
	| { type: ProviderType.YARDI; credentials: YardiCredentials }
	| { type: ProviderType.APP_FOOLIO; credentials: AppFoolioCredentials }
	| { type: ProviderType.OPINIION; credentials: OpiniionCredentials }
	| { type: ProviderType.GADMIN; credentials: GAdminCredentials }
	| { type: ProviderType.GMELIUS; credentials: GmeliusCredentials }
	| { type: ProviderType.QUICKBOOKS; credentials: QuickbooksCredentials }
	| { type: ProviderType.ZOOM; credentials: ZoomCredentials }
	| { type: ProviderType.PODIUM; credentials: PodiumCredentials }
	| { type: ProviderType.GOTO_CONNECT; credentials: GoToConnectCredentials }
	| { type: ProviderType.CALL_LINKS; credentials: CallLinksCredentials }
	| { type: ProviderType.SHOWMOJO; credentials: ShowMojoCredentials }
	| { type: ProviderType.ASANA; credentials: AsanaCredentials }
	| { type: ProviderType.RENTVINE; credentials: RentvineCredentials }
	| { type: ProviderType.RENTENGINE; credentials: RentEngineCredentials };

export interface DataProvider {
	id: string;
	type: ProviderType;
	credentials:
		| YardiCredentials
		| AppFoolioCredentials
		| OpiniionCredentials
		| GAdminCredentials
		| GmeliusCredentials
		| QuickbooksCredentials
		| ZoomCredentials
		| PodiumCredentials
		| GoToConnectCredentials
		| CallLinksCredentials
		| ShowMojoCredentials
		| AsanaCredentials
		| RentvineCredentials
		| RentEngineCredentials
		| any;
	createdAt: string;
	updatedAt: string;
}
